import trim from 'lodash/trim';

export default function (text) {
  // TODO: enhance this to account for scripts, html etc.
  return trim(text);
}
